(function () {
  const FREE_GIFT_VARIANT_ID = 14214927614015;
  const TRIGGER_SIZE = '945';
  let isSyncing = false;

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function count945InCart(cart) {
    let count = 0;
    for (const item of cart.items) {
      if (item.variant_id === FREE_GIFT_VARIANT_ID) continue;
      // Check variant_title and options_with_values directly from cart
      const variantTitle = (item.variant_title || '').toLowerCase();
      const options = (item.options_with_values || []).map(o => (o.value || '').toLowerCase());
      if (variantTitle.includes(TRIGGER_SIZE) || options.some(o => o.includes(TRIGGER_SIZE))) {
        count += item.quantity;
      }
    }
    return count;
  }

  async function syncFreeGift() {
    if (isSyncing) return;
    isSyncing = true;

    try {
      const cart = await getCart();
      const qty945 = count945InCart(cart); // no more async per item!
      const giftItem = cart.items.find(item => item.variant_id === FREE_GIFT_VARIANT_ID);
      const currentGiftQty = giftItem ? giftItem.quantity : 0;

      if (qty945 === currentGiftQty) return;

      if (qty945 === 0) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: FREE_GIFT_VARIANT_ID, quantity: 0 })
        });
      } else if (currentGiftQty === 0) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: FREE_GIFT_VARIANT_ID,
              quantity: qty945,
              properties: { _free_gift: 'true' }
            }]
          })
        });
      } else {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: FREE_GIFT_VARIANT_ID, quantity: qty945 })
        });
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));

    } catch (err) {
      console.error('Free gift sync error:', err);
    } finally {
      isSyncing = false;
    }
  }

  function isGiftCall(args) {
    try {
      const body = args[1]?.body;
      if (typeof body === 'string') {
        const parsed = JSON.parse(body);
        const ids = parsed.items?.map(i => Number(i.id)) || [Number(parsed.id)];
        return ids.includes(FREE_GIFT_VARIANT_ID);
      }
    } catch (_) {}
    return false;
  }

  // Intercept fetch
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const result = await originalFetch(...args);

    const isCartCall = url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update');
    if (isCartCall && !isGiftCall(args)) {
      setTimeout(syncFreeGift, 800);
    }

    return result;
  };

  // Intercept XMLHttpRequest
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._url = url;
    return originalOpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (body) {
    const url = this._url || '';
    if (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/add')) {
      try {
        if (typeof body === 'string') {
          const parsed = JSON.parse(body);
          const ids = parsed.items?.map(i => Number(i.id)) || [Number(parsed.id)];
          if (!ids.includes(FREE_GIFT_VARIANT_ID)) {
            this.addEventListener('load', () => setTimeout(syncFreeGift, 800));
          }
        }
      } catch (_) {
        this.addEventListener('load', () => setTimeout(syncFreeGift, 800));
      }
    }
    return originalSend.call(this, body);
  };

})();


